import { FetchHomePageOptionsActionTypes } from '../actions/NavConfigActions';
import { handleActions } from 'flux-actions';
const initialState = [];
export default handleActions({
  [FetchHomePageOptionsActionTypes.SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    return action.payload.data;
  }
}, initialState);